export default __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-cd6390b96ce2825615c132d5b6c771b4.eot";